module.exports = __webpack_public_path__ + "da2d3cac96eefcfe60422354fbd45eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/fotl-ladies-purple.jpg
// module id = 831
// module chunks = 0